import React, { Component } from 'react';
import { isEqual } from 'lodash';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import { getHelpText } from 'helpers/glossary';
import TreemapCallOutChart from 'components/molecules/charts/TreemapCallOutChart';
import ExportableCalloutWithTreemap from 'containers/callouts/ExportableCalloutWithTreemap';
import { formatNumbers } from 'helpers/formatNumbers';
import ContentTile from 'components/atoms/layout/ContentTile';
import helpers from 'helpers';
import CallOutWrapper from 'components/atoms/callout/CallOutWrapper';
import Title from 'components/atoms/callout/Title';
import Value from 'components/atoms/callout/Value';
import {
    HelpBox,
    HelpClose,
    HelpBody,
    HelpTitle,
    HelpIcon,
} from 'components/atoms/callout/Help';

const TreeMapWrapper = styled.div`
    padding-top: 5px;
    width: 95%;
`;

class CallOutValueWithTreemap extends Component {
    constructor(props) {
        super(props);
        this.state = { toggleHelp: false };
        this.toggleHelp = this.toggleHelp.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return !isEqual(nextProps.data, this.props.data) ||
            !isEqual(nextState.toggleHelp, this.state.toggleHelp);
    }

    toggleHelp() {
        this.setState({ toggleHelp: !this.state.toggleHelp });
    }

    render() {
        const { enabledChannels } = this.props;
        const { orderedColors } = this.props.theme;
        const { value, treeMap, channels, accessor } = this.props.data;
        const valueDisplay = formatNumbers(value, this.props.format);
        const helpText = getHelpText({ glossaryKey: 'channelsLive' });

        const treeMapData = [];
        helpers.orderedChannelKeys(enabledChannels).forEach((channel, index) => {
            // Treemap charts do not render an artifacrt for 0 data. So, filter them.
            if (!treeMap[channel] || treeMap[channel][accessor] === 0) {
                return;
            }

            if (channels.indexOf(channel) === -1) {
                return;
            }

            treeMapData.push({
                name: helpers.convertToDisplayValue(channel),
                value: treeMap[channel][accessor],
                color: orderedColors[index % orderedColors.length]
            });
        });
        const shouldRenderTreeMap = treeMapData.length > 0;

        return (
            <ContentTile>
                <CallOutWrapper data={this.props.data}>
                    <Value>{valueDisplay}</Value>
                    <Title>{this.props.title}</Title>
                    <HelpIcon className="icon-help-circle" onClick={this.toggleHelp.bind(this)} />
                    {shouldRenderTreeMap ?
                        <React.Fragment>
                            <TreeMapWrapper>
                                <TreemapCallOutChart
                                    data={treeMapData}
                                    formatByType="priceWithoutSpace"
                                    exportName={`${this.props.exportName}-treemap`} />
                            </TreeMapWrapper>
                        </React.Fragment>
                        : null}
                    <HelpBox
                        onClick={this.toggleHelp.bind(this)}
                        className={this.state.toggleHelp ? 'show-help' : 'hide-help'} >
                        <HelpTitle>{this.props.title}</HelpTitle>
                        <HelpBody>{helpText}</HelpBody>
                        <HelpClose className="icon-close-circle"/>
                    </HelpBox>
                    <ExportableCalloutWithTreemap
                        exportName={this.props.exportName}
                        title={this.props.title}
                        value={valueDisplay} />
                </CallOutWrapper>
            </ContentTile>
        );
    }
}

CallOutValueWithTreemap.propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.shape({
        value: PropTypes.number.isRequired,
        treeMap: PropTypes.object.isRequired,
        channels: PropTypes.arrayOf(PropTypes.string).isRequired,
        accessor: PropTypes.string.isRequired
    }),
    format: PropTypes.string,
    exportName: PropTypes.string.isRequired,
    enabledChannels: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default withTheme(CallOutValueWithTreemap);



// WEBPACK FOOTER //
// ./src/components/molecules/CallOutValueWithTreemap.js